import { normalizeApiOrigin } from '../../../shared/lib/apiOrigin';

/**
 * Hosts do painel admin em produção NaviExperience (sem VITE_API_URL no build).
 * O CloudFront do site **não** expõe POST /api — a API fica em api.naviexperience.com (API Gateway).
 */
const NAVIEX_ADMIN_PROD_HOSTNAMES = new Set(['naviexperience.com', 'www.naviexperience.com']);
const NAVIEX_PROD_API_ORIGIN = 'https://api.naviexperience.com';

/**
 * Origem da API (sem `/api` no fim).
 * - `VITE_API_URL` no build tem prioridade.
 * - Em **www** ou **apex** `naviexperience.com`, usa `https://api.naviexperience.com`.
 * - Em dev local (Vite), string vazia → `apiUrl` usa o origin do browser e o proxy `/api` → :5000.
 */
export function getApiBase(): string {
  const raw = typeof import.meta.env.VITE_API_URL === 'string' ? import.meta.env.VITE_API_URL.trim() : '';
  if (raw !== '') return normalizeApiOrigin(raw);
  if (typeof window !== 'undefined') {
    const h = window.location.hostname.toLowerCase();
    if (NAVIEX_ADMIN_PROD_HOSTNAMES.has(h)) return NAVIEX_PROD_API_ORIGIN;
  }
  return '';
}

export function apiUrl(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`;
  const base = getApiBase();
  if (base) return `${base}${p}`;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return new URL(p, window.location.origin).href;
  }
  return p;
}
